// extracted by mini-css-extract-plugin
module.exports = {"declaration":"E9FEWN5imkal4P+qvnJ99w==","footer":"kgNe7A7RCY4toPbFTGk4-w=="};